import api from './client';

export const dropdownService = {
    getAllAccordingToParagraph: async () => {
        const response = await api.get('according-to-paragraph');
        return response.data;
    },
};